import React, { useState } from "react";
import { useParams } from "react-router-dom";

import {
  client,
  serverUrl,
  apiEndpoints,
  assetBase,
} from "../../config";
import PostSingle from "../../partials/posts/postSingle";

export default function VideoSingle(props) {
  const [post, setPost] = useState(null);
  const params = useParams();

  const videoLoaded = (id) => {
    const videoElement = document.querySelector(`video[data-id="${id}"]`);

    new window.Plyr(videoElement, {
      controls: [
        "play-large",
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
      ],
    });
  };

  const getPlyrEmbedUrl = (url) => {
    try {
      const u = new URL(url);

      if (u.hostname.includes("youtube.com")) {
        return `https://www.youtube.com/embed/${u.searchParams.get("v")}`;
      }
      if (u.hostname.includes("youtu.be")) {
        return `https://www.youtube.com/embed${u.pathname}`;
      }
      if (u.hostname.includes("vimeo.com")) {
        return `https://player.vimeo.com/video${u.pathname}`;
      }

      return url;
    } catch {
      return url;
    }
  };

  const renderPostVideo = (post) => {
    const autoplay = client === "equans" ? true : false;
    const id = params.id;

    let isRemote = false;
    let videoSource;

    if (client === "companyapp") {
      const fileToken = post.file_access_token;
      if (post.field_media_oembed_video) {
        videoSource = getPlyrEmbedUrl(post.field_media_oembed_video);
        isRemote = true;
      } else if (!props.preview) {
        // Published: signed, same-origin asset from book.json.
        // field_video is a relative `assets/<file>?sig=…` path; assetBase
        // resolves same-origin off the NFS symlink on deployed hosts
        // (dev-files on localhost) and the sig is verified there.
        videoSource = `${assetBase}/video/${id}/${id}/${post.field_video}`;
      } else {
        // Preview (unpublished draft): served by Drupal.
        videoSource = fileToken
          ? `${serverUrl}/shared/files/${post.filename}?access_token=${fileToken}`
          : `${serverUrl}/api/v2/assets?mid=${post.mid}`;
      }
    } else {
      videoSource = `${serverUrl}${
        post.field_media_video_file
          ? post.field_media_video_file
          : post.field_video
      }`;
    }

    return (
      <div className="post-video-container-redactor" style={{ position: "relative" }}>
        {isRemote ? (
          <div className="plyr__video-embed">
            <iframe
              src={videoSource}
              allowFullscreen
              allow="autoplay; encrypted-media"
              title={post.title}
            ></iframe>
          </div>
        ) : (
          <video
            data-id={post.id}
            controls
            autoPlay={autoplay}
            className="post-video plyr"
            onLoadedMetadata={() => {
              videoLoaded(post.id);
            }}
          >
            <source src={videoSource} alt={`Video for ${post.title}`} />
          </video>
        )}
      </div>
    );
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.videos}
      entityFavoritesContentType={"video"}
      previewReturnRoute={"/videos-creator"}
      returnRoute={"/videos"}
      backBtnText={"Video Library"}
      screenClassName={"videos"}
      v2Bundle={"video"}
      logCustomEventType={"Video"}
      entityType={"video"}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {post && renderPostVideo(post)}
    </PostSingle>
  );
}
